import { Outlet } from "react-router-dom"

const AdminBulkUpdatesScreen = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default AdminBulkUpdatesScreen
